import EventMonthList from './EventMonthList';
import DateFormatter from '../../date/EventListingDateFormatter';

class EventDayList extends EventMonthList {

  constructor() {
    super();
    this.resultsFormatter = DateFormatter.standardDate;
    this.dayFormatter = DateFormatter.weekdayLabel;
  }

}

export default EventDayList;



// WEBPACK FOOTER //
// ./V7/events/listing/calendarView/html/EventDayList.js